import{createPluginCenter as e,request as t,markdown as n}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isCancel,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import o from"url";import{jsx as r,Fragment as i,jsxs as s}from"react/jsx-runtime";import a,{Suspense as c,Fragment as l,Component as d,useMemo as u,createElement as h,createContext as m,useContext as p,useState as f,useCallback as g,useEffect as b,useRef as w,Children as v}from"react";import x from"@babel/runtime/helpers/defineProperty";import{useSelector as y,Model as k,createStore as E,Provider as S,useActions as C}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import $ from"loadjs";export{default as loadjs}from"loadjs";import P from"query-string";import M,{createGlobalStyle as L}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{createIntlCache as z,createIntl as j,RawIntlProvider as D}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import T from"remark-slug";import{toc as A}from"mdast-util-toc";import{all as I,toHast as O}from"mdast-util-to-hast";import{convert as _}from"unist-util-is";import{toString as N}from"mdast-util-to-string";import{encode as W}from"mdurl";import F from"html-tags";import{debounce as U,throttle as V}from"lodash";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback}from"react-async-hook";export{Helmet}from"react-helmet";window.TopWritePlugins={};class q extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=o.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function H(e){let{component:t,defaultComponent:n=l,props:o,children:i=null,context:s}=e;return null===t?null:r(c,{fallback:null,children:r(t,{props:o,Component:n,context:s,children:i})})}customElements.define("t-attachment",q);class B extends d{constructor(){super(...arguments),x(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var R=(e,t)=>e.filter((e=>{let{descriptor:n}=e;return t===n.role})).sort(((e,t)=>{let{descriptor:{priority:n=0}}=e,{descriptor:{priority:o=0}}=t;return n-o})).map((e=>{return t=e.Component,e=>r(B,{children:r(t,{...e},"WrappedComponent")});var t}));function G(e){let{component:t,props:n}=e;return h(t,n)}function J(e){let{props:t,role:n,component:o,context:i}=e;const s=o?r(G,{component:o,props:t,context:i}):null,a=y("components");return u((()=>R(a,n)),[a,n]).reduce(((e,n)=>r(H,{defaultComponent:o,component:n,props:t,context:i,children:e})),s)}function K(e){let{props:t,component:n,role:o,context:s}=e;const a=y("components"),c=u((()=>R(a,o)),[a,o]);return r(i,{children:c.map(((e,o)=>r(H,{defaultComponent:n,component:e,props:t,context:s},o)))})}async function Q(e){let t=`topwrite-plugin-${e.name}`;if(!$.isDefined(t)){let n=`${e.host}/${e.main}`;try{await $(n,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}const X="localStorage";function Y(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:X;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const Z={get:()=>null,set:()=>{},del:()=>{}},ee=(e,t)=>{const n=Y(t?.persistence);return n?{get:()=>n.getItem(e),set:t=>n.setItem(e,t),del:()=>n.removeItem(e)}:Z};function te(){const e=Y(arguments.length>0&&void 0!==arguments[0]?arguments[0]:X);if(!e)return[];const t=[];for(let n=0;n<e.length;n+=1){const o=e.key(n);null!==o&&t.push(o)}return t}function ne(e,t){if(null===e)return t;if(void 0===t||"string"==typeof t)return e;try{return JSON.parse(e)}catch{return t}}class oe{constructor(){x(this,"listeners",new Map),x(this,"values",new Map)}subscribe(e,t){return this.listeners.has(e)||this.listeners.set(e,new Set),this.listeners.get(e).add(t),()=>{const n=this.listeners.get(e);n&&(n.delete(t),0===n.size&&this.listeners.delete(e))}}setValue(e,t,n){this.values.set(e,t);const o=ee(e);t===n?o.del():o.set(function(e){return void 0===e||"string"==typeof e?e:JSON.stringify(e)}(t));const r=this.listeners.get(e);r&&r.forEach((e=>e(t)))}getValue(e,t){if(this.values.has(e))return this.values.get(e);const n=ne(ee(e).get(),t);return this.values.set(e,n),n}handleStorageEvent(e,t){if(e.key&&this.listeners.has(e.key)){const n=t.get(e.key),o=ne(e.newValue,n);this.values.set(e.key,o);const r=this.listeners.get(e.key);r&&r.forEach((e=>e(o)))}}}const re=m(null);function ie(e){let{children:t}=e;const n=u((()=>new oe),[]),o=u((()=>new Map),[]);return b((()=>{const e=e=>{n.handleStorageEvent(e,o)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)}),[n,o]),r(re.Provider,{value:n,children:t})}function se(e,t){const n=p(re);if(!n)throw new Error("useLocalStorageState must be used within a LocalStorageStateProvider");const[o,r]=f((()=>n.getValue(e,t))),i=g((o=>{n.setValue(e,o,t)}),[n,e,t]);return b((()=>n.subscribe(e,r)),[n,e]),[o,i]}function ae(e,t){let n;return n=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},n}function ce(){const e=y("book");if(!e)throw new Error("book object not initialized");return e}const le={light:"light",dark:"dark"},de=e=>e===le.dark?le.dark:le.light,ue=window.matchMedia?window.matchMedia("(prefers-color-scheme: dark)"):void 0,he=()=>ue?.matches?le.dark:le.light,me=e=>{document.documentElement.setAttribute("data-theme",e)},pe=m(void 0);function fe(e){let{children:t,context:n,theme:o}=e;const i=ce(),[s,a]=se(`${n}.${i.id}.theme`,"auto"),[c,l]=f((()=>{let e;return e=o||"auto"!==s?de(o||s):he(),e}));b((()=>{if(ue&&!o&&"auto"===s){const e=e=>{e.matches?l(le.dark):l(le.light)};return ue.addEventListener("change",e),()=>{ue.removeEventListener("change",e)}}}),[s,o]),b((()=>{l("auto"==s?o||he():de(s))}),[s]),b((()=>{me(c)}),[c]);const d=g((()=>{a(le.light)}),[]),u=g((()=>{a(le.dark)}),[]),h=g((()=>{a("auto")}),[]),m=g((()=>{"auto"===s?d():c===le.light?u():h()}),[c,s,d,u]);return r(pe.Provider,{value:{theme:c,isAutoTheme:"auto"===s,isDarkTheme:c===le.dark,setLightTheme:d,setDarkTheme:u,setAutoTheme:h,toggleTheme:m},children:t})}function ge(){const e=p(pe);if(!e)throw new Error("theme context not exist");return e}const be=L`
    :root {
        --ttw-color: #333;
        --ttw-primary-color: #3c60ff;
        --ttw-secondary-color: #9e9e9e;
        --ttw-gray-color: rgba(0, 0, 0, 0.5);
        --ttw-background: #fff;
        --ttw-border-color: #eaeaea;
        --ttw-box-color: #212529;
        --ttw-box-background: #FFF;
        --ttw-box-hover-background: #e9ecef;
        --ttw-box-active-background: #f1f2f2;
    }

    [data-theme=dark] {
        --ttw-color: #cacbcf;
        --ttw-secondary-color: #888;
        --ttw-gray-color: rgba(255, 255, 255, 0.5);
        --ttw-background: #1F2428;
        --ttw-border-color: #1B1F23;
        --ttw-box-color: #e1e4e8;
        --ttw-box-background: #2f363d;
        --ttw-box-hover-background: #39414a;
        --ttw-box-active-background: #242A30;
    }
    
    //TODO 转移到异步加载
    //附件
    t-attachment {
        color: var(--ttw-primary-color, #3c60ff);
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        padding: 0 4px;
        vertical-align: bottom;
        margin: 0 1px;

        &:before {
            content: '';
            width: 18px;
            height: 18px;
            background-color: var(--ttw-primary-color, #3c60ff);
            mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
            margin-right: 4px;
        }

        &:after {
            content: "(" attr(size) ")";
            margin-left: 4px;
            display: none;
        }

        &[size]:after {
            display: inline;
        }

        &:hover {
            background: rgba(0, 0, 0, .1);
        }

        &:read-write {
            cursor: text;
        }
    }
`;const we=new class extends k{constructor(){super(...arguments),x(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const ve=new class extends k{};var xe=Object.freeze({__proto__:null,components:we,options:ve});const ye=m(void 0),ke=()=>{const e=p(ye);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},Ee=e=>{let{children:t}=e;const{locale:n,messages:o}=ke(),i=u((()=>{const e=z();return j({locale:n,messages:o,defaultLocale:"en"},e)}),[n,o]);return r(D,{value:i,children:t})},Se=e=>{let{children:t,locale:n,messages:o}=e;const[i,s]=f(o);return r(ye.Provider,{value:{locale:n,messages:i,setMessages:s},children:r(Ee,{children:t})})};function Ce(e){return e.__esModule&&e.default?e.default:e}class $e{constructor(e,t,n){x(this,"name",void 0),x(this,"book",void 0),x(this,"models",{...xe}),x(this,"components",[]),x(this,"activates",[]),x(this,"plugins",[]),x(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=n}registerComponents(e,t){for(let[n,o]of Object.entries(e))o&&("plugin:setting"===n&&(n=`plugin:setting:${t}`),this.components.push(ae(n,o)))}registerModels(e,t){for(const[n,o]of Object.entries(e))t?this.models[`@${t}@${n}`]=o:this.models[n]=o}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:navigator.language,n=arguments.length>2?arguments[2]:void 0;t=this.detectLocale(t);const o=await this.loadMessages(t,e),a=E(this.models,{book:this.book,components:this.components,...this.initialState}),c=e=>{let{children:t}=e;return r(i,{children:t})},l=e=>{let{children:t}=e;const n=r(J,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:c});return this.activates.reduce(((e,t)=>{const n=t(this.name);return void 0!==n?r(i,{children:n}):e}),n)};return e=>{let{children:i}=e;return r(S,{store:a,children:r(ie,{children:s(fe,{context:this.name,theme:n,children:[r(be,{}),r(Se,{locale:t,messages:o,children:r(l,{children:i})})]})})})}}detectLocale(e){const t=ee(`${this.name}.${this.book.id}.lang`);e=t.get()||e;const n=new URLSearchParams(window.location.search).get("lang");return n&&(t.set(n),e=n),document.documentElement.setAttribute("lang",e),e}async loadMessages(e,t){return await this.plugins.reduce((async(t,n)=>{const o=Ce(await t);return n.localize?Object.assign({},o,Ce(await n.localize(e))):o}),t(e))}}async function Pe(n){const{name:o,book:r,models:i,initialState:s,localize:a,pluginCenter:c,locale:l,theme:d}=n,u=await async function(n,o){let r=[];if(o){const t=e(o);try{r=await t.getInstalled(n),r=r.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),n=P.parse(window.location.search);if("dev"in n||e){const o=n.dev||e||8080;try{const e=(await t.get(`http://localhost:${o}/meta`)).data;r=r.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],r.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(o))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),s=i.some((e=>"theme"===e.type)),a=Object.keys(window.TopWritePlugins),c=[];for(let e of r)e.disabled||a.includes(e.name)||s&&"theme"===e.type||c.push(Q(e));return await Promise.all(c),i.push(...r),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(r,c),h=new $e(o,r,s);return h.registerModels(i),await h.registerPlugins(u),await h.createApp(a,l,d)}function Me(e){return C(e)}function Le(e){return y(e)}function ze(e){return[Le(e),Me(e)]}function je(e,t,n){const o="function"==typeof t;o||(n=t),b((()=>{let n;const r=e();return Promise.resolve(r).then((e=>{n=e})),()=>{o&&t(n)}}),n)}function De(e){const t=w(null),[n,o]=f(e);b((()=>{t.current&&(t.current(),t.current=null)}),[n]);return[n,(e,n)=>{t.current="function"==typeof n?n:null,o(e)}]}function Te(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class Ae{constructor(e){let{name:t,meta:n,models:o={},components:r={},activate:i,register:s,localize:a,config:c}=e;x(this,"name",void 0),x(this,"config",void 0),x(this,"localize",void 0),x(this,"models",void 0),x(this,"components",void 0),x(this,"activate",void 0),x(this,"register",void 0),x(this,"meta",void 0),this.name=t,this.meta=n,this.models=o,this.components=r,this.activate=i,this.register=s,this.localize=a,this.config=c}}const Ie=m({}),Oe=Ie.Provider,_e=()=>p(Ie);function Ne(e,t){return _e()[e]||t}const We=_("root"),Fe=_("element"),Ue=_("text");function Ve(e){return e.filter((e=>!(Ue(e)&&"\n"===e.value)))}function qe(e,t,n){const o=t.properties,r=t.tagName,i={...o};n.prefix&&(n.key++,i.key=n.prefix+n.key);const s=[],a=Ve(t.children),c=a?a.length:0;let l=-1;for(;++l<c;){const t=a[l];Fe(t)?s.push(qe(e,t,n)):Ue(t)&&s.push(t.value)}return e.call(t,r,i,s.length>0?s:void 0)}function He(e,t){let{extensions:n=[],creator:o=a.createElement}=t;const r={allowDangerousHtml:!1,handlers:{...n.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},I(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},I(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let n=!1;for(const e of t.children)if(e.data?.directiveLabel){n=!0;break}return n||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},I(e,t))},heading(e,t){const n=e(t,"heading",I(e,t));return n.properties={...n.properties,depth:t.depth},n}},unknownHandler:()=>null},i=O(e,r);if(We(i))return Ve(i.children).map(((e,t)=>Fe(e)?qe(o,e,{key:0,prefix:`h-${t}-`}):Ue(e)?e.value:void 0));if(!Fe(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return qe(o,i,{key:0,prefix:"h-"})}function Be(e){let{extensions:t,tree:n,options:o}=e;const a=u((()=>{let e=null;if(o){const r=A(n).map;r&&(e=He(r,{extensions:[...t,{link:(e,t)=>{const n=N(t.children);return e(t,"a",{href:W(t.url)},[{type:"text",value:n}])}}]})),"object"==typeof o&&(e=s(i,{children:[o.header,e,o.footer]}))}return e}),[t,n,o]);return a?r("aside",{children:a}):null}const Re=e=>{let{value:t}=e;return r("pre",{children:r("code",{children:t})})},Ge=e=>{let{value:t}=e;return r("code",{children:t})};const Je=["video","audio"];function Ke(e){const{name:t,attributes:n,children:o}=e;let i=Ne(t),s=`html:${t}`;return customElements.get(`t-${t}`)?i=i||`t-${t}`:Je.includes(t)||(i=void 0,s=`directive:${t}`),r(J,{role:s,props:{...n,children:o},component:i})}function Qe(e){let{depth:t=5,...n}=e;return h(`h${t}`,n)}const Xe={"x-inline":function(e){const{name:t,value:n}=e;return r(J,{role:`inline:${t}`,props:{type:"inline",name:t,value:n},component:Ge})},"x-block":function(e){const{name:t,value:n,parameter:o}=e;return r(J,{role:`block:${t}`,props:{type:"block",name:t,parameter:o,value:n},component:Re})},textDirective:Ke,leafDirective:Ke,containerDirective:function(e){let{name:t,attributes:n,children:o}=e,i=Ne(t),s=`html:${t}`;const[a,...c]=v.toArray(o),l={children:c,label:a,...n};return customElements.get(`t-${t}`)?i=i||`t-${t}`:Je.includes(t)||(i=void 0,s=`directive:${t}`),r(J,{role:s,props:l,component:i})},heading:function(e){const t=Ne("heading",Qe);return r(J,{role:"html:heading",props:e,component:t})}},Ye=e=>{let{tagName:t,inject:n=!0,...o}=e;const i=Ne(t,t);return n?Xe[t]?h(Xe[t],o):F.includes(t)?r(J,{role:`html:${t}`,props:o,component:i}):(console.warn(`unknown tagName: ${t}`),null):h(i,o)};function Ze(e){let{tree:t,extensions:n,as:o,css:i,header:a,footer:c,inject:l}=e;const d=u((()=>He(t,{extensions:n,creator:(e,t,n)=>h(Ye,{...t,tagName:e,inject:l},n)})),[t,n]);return s("article",{children:[a,r(et,{$css:i,as:o,children:d}),c]})}const et=M.section`
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    line-height: 1.2;
    word-wrap: break-word;

    & > *:first-child {
        margin-top: 0 !important;
    }

    & > *:last-child {
        margin-bottom: 0 !important;
    }

    h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
        margin-top: 0;
        margin-bottom: 1rem;
        line-height: 1.5;
        padding: 0;

        &:last-child {
            margin-bottom: 0 !important;
        }

        &:first-child {
            margin-top: 0 !important;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 500;
        margin-top: 2rem;
        margin-bottom: 1rem;
        line-height: 1.2;

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    h1 {
        font-size: 2.5em;
    }

    h2 {
        font-size: 2em;
    }

    h3 {
        font-size: 1.75em;
    }

    h4 {
        font-size: 1.5em;
    }

    h5 {
        font-size: 1.25em;
    }

    hr {
        border: 0;
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 0.5em;
    }

    ul {
        padding-left: 2em;

        ul {
            margin: 0;
        }
    }

    ol {
        padding-left: 2em;
    }

    li {
        line-height: 2;

        &.task-list-item {
            list-style: none;
            position: relative;

            input[type=checkbox] {
                position: absolute;
                left: -1.5em;
                top: 0.5em;
                width: 1em;
                height: 1em;
            }
        }

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    code {
        display: inline-block;
        border-radius: 4px;
        padding: .2em .4em;
        background-color: #f7f7f7;
        word-break: break-all;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        white-space: pre;
        line-height: 1.3;
        color: inherit;
        font-size: inherit;
        margin: -.2em .4em;
    }

    pre {
        padding: 1.05em;
        overflow: auto;
        line-height: 1.45;
        background-color: #f7f7f7;
        border: 0;
        border-radius: 3px;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        font-size: inherit;
    }


    pre > code {
        display: inline;
        max-width: 100%;
        padding: 0;
        margin: 0;
        overflow: initial;
        line-height: inherit;
        background-color: rgba(0, 0, 0, 0);
        border: 0;
        tab-size: 4;
    }

    p {
        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        line-height: 1.8;
        border-spacing: 0;

        th {
            text-align: left;

            &[align='center'] {
                text-align: center;
            }

            &[align='right'] {
                text-align: right;
            }
        }

        th, td {
            border: 1px solid #e0e0e0;
            padding: 3px 12px;
            height: 34px;
        }

        tr:hover td {
            background-color: #f1f1f1;
        }
    }

    img {
        max-width: 100%;
        display: inline-block;
        padding: 3px;
        vertical-align: middle;
    }

    a {
        text-decoration: none;
        color: var(--ttw-primary-color, #3c60ff);

        &:hover {
            text-decoration: underline;
        }
    }

    blockquote {
        padding: 5px 5px 5px 15px;
        color: #858585;
        border-left: 4px solid #e5e5e5;

        &.info {
            border-left-color: #5bc0de;
            color: #5bc0de;
            background-color: #f4f8fa;
        }

        &.warning {
            background-color: #fcf8f2;
            border-color: #f0ad4e;
            color: #f0ad4e;
        }

        &.danger {
            color: #d9534f;
            background-color: #fdf7f7;
            border-color: #d9534f;
        }

        &.success {
            background-color: #f3f8f3;
            border-color: #50af51;
            color: #50af51;
        }
    }

    video {
        display: block;
        width: 100%;
    }

    audio {
        display: block;
        width: 100%;
    }

    [data-theme=dark] & {
        code {
            background-color: #333437;
        }

        pre {
            background-color: #333437;
        }

        h1, h2, hr {
            border-color: #404040;
        }

        th, td {
            border-color: #404040;
        }

        tr:hover td {
            background-color: #333437;
        }

        blockquote {
            border-left-color: #858585;

            &.info {
                border-left-color: rgb(27, 110, 134);
                color: rgb(98, 195, 223);
                background-color: rgb(19, 34, 42);
            }

            &.warning {
                background-color: rgb(49, 34, 11);
                border-color: rgb(147, 91, 12);
                color: rgb(241, 176, 84);
            }

            &.danger {
                color: rgb(219, 94, 90);
                background-color: rgb(46, 11, 11);
                border-color: rgb(137, 33, 30);
            }

            &.success {
                background-color: rgb(27, 39, 23);
                border-color: rgb(56, 122, 57);
                color: rgb(98, 183, 98);
            }
        }
    }

    ${e=>e.$css}
`;function tt(e){let{as:t=l,children:o,components:i={},aside:a=!0,header:c,footer:d,css:m,sectionAs:p,inject:g=!0,loader:w=null,onShow:v,...x}=e;const y=u((()=>n().use(T).freeze()),[]),[k,E]=f(w),[S,C]=f(null);return je((async()=>{try{const e=await y.run(y.parse(o));C(e)}catch(e){console.warn(e),C(!1)}}),[o,y]),b((()=>{if(null!==S){if(!1===S)E(null);else if(S){const e=y.data("toHastExtensions");E(s(Oe,{value:i,children:[r(Ze,{tree:S,extensions:e,header:c,footer:d,as:p,css:m,inject:g}),r(Be,{tree:S,extensions:e,options:a})]}))}v&&requestAnimationFrame(v)}}),[S,a,c,d,m,p,g]),h(t,x,k)}function nt(e){let{onChange:t,onCompositionStart:n,onCompositionEnd:o,...i}=e;const s=w(!1),a=g((e=>{s.current||t?.(e)}),[t]),c=g((e=>{s.current=!0,n?.(e)}),[n]),l=g((e=>{s.current=!1,t?.(e),o?.(e)}),[o,t]);return r("input",{...i,onChange:a,onCompositionStart:c,onCompositionEnd:l})}function ot(e){const t=w();return b((()=>{t.current=e}),[e]),t.current}function rt(){const{config:e}=ce();return e.getValue("themeConfig")}function it(e){const t=w(e);b((()=>(document.title=e,()=>{document.title=t.current})),[e])}function st(e,t,n){const o=w(e),r=w(U(e,t,n));return b((()=>{o.current=e})),b((()=>{r.current=U((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function at(e,t,n){const o=w(e),r=w(V(e,t,n));return b((()=>{o.current=e})),b((()=>{r.current=V((function(){o.current(...arguments)}),t,n)}),[t,n]),r.current}function ct(){return y("options")}const lt=new EventTarget;function dt(){return lt}function ut(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var ht=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function mt(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}export{nt as CompositionInput,J as InjectedComponent,K as InjectedComponentSet,tt as Markdown,Ae as Plugin,ht as base64,Pe as createApplication,ae as createComponentDescriptor,ee as createStorageSlot,ut as getPayload,Te as getPublicPath,mt as isMac,te as listStorageKeys,Me as useActions,je as useAsyncEffect,ce as useBook,st as useDebounce,it as useDocumentTitle,dt as useEventTarget,ke as useIntlContext,se as useLocalStorageState,ze as useModel,ct as useOptions,ot as usePrevious,Le as useSelector,De as useStateWithCallback,rt as useThemeConfig,ge as useThemeContext,at as useThrottle};
//# sourceMappingURL=index.js.map
